import { Dispatch, FC, Fragment, SetStateAction, useMemo, useRef } from "react";
import { Box } from "@mui/material";
import { GridApi } from "ag-grid-community";
import { ResourcesMasterGrid } from "@/components/pages/common/resources-ag-grid/ResourcesMasterGrid";
import { ResourcesGridResourcePayloadType } from "@/store/resources-grid/utils/types/common";
import { ResourceFilters } from "@/services/cloudchipr.api";
import { ResourcesAgGridHiddenActions } from "@/components/pages/common/resources-ag-grid/utils/types/common";
import { automationsFoundResourcesGridUpcomingActionsColumDef } from "@/components/pages/automations/common/components/found-resources/components/grid/automationsFoundResourcesGridUpcomingActionsColumDef";

interface AutomationsFoundResourcesGridProps {
  accountIds: string[];
  regions: string[];
  filter: ResourceFilters;
  gridApi: GridApi | null;
  masterGridId: string;
  singleGrid: boolean;
  gracePeriodEnabled: boolean;
  setGridApi: Dispatch<SetStateAction<GridApi | null>>;
}

export const AutomationsFoundResourcesGrid: FC<
  AutomationsFoundResourcesGridProps
> = ({
  filter,
  accountIds,
  regions,
  masterGridId,
  singleGrid,
  gracePeriodEnabled,
  gridApi,
  setGridApi,
}) => {
  const sizeRef = useRef<HTMLDivElement | null>(null);
  const resourceType = filter?.type;

  const dataToFetchResources: ResourcesGridResourcePayloadType = useMemo(() => {
    return {
      resourceFilters: filter,
      accountIds: accountIds,
      regions: regions,
    };
  }, [accountIds, filter, regions]);

  if (!resourceType) {
    return null;
  }

  const additionalColumns = gracePeriodEnabled
    ? [automationsFoundResourcesGridUpcomingActionsColumDef]
    : undefined;

  return (
    <Fragment>
      <ResourcesMasterGrid
        notFullHeight
        gridApi={gridApi}
        setGridApi={setGridApi}
        preventDetailsDrawerOpener
        resourceType={resourceType}
        masterGridId={masterGridId}
        hiddenActions={hiddenActions}
        masterResourceType={resourceType}
        additionalColumns={additionalColumns}
        dataToFetchResources={dataToFetchResources}
        gridMaxHeight={singleGrid ? sizeRef.current?.clientHeight : 265}
      />

      <Box top={0} left={0} ref={sizeRef} position="fixed" height="89dvh" />
    </Fragment>
  );
};

const hiddenActions: ResourcesAgGridHiddenActions = [
  "workflowCreate",
  "clean",
  "createTask",
  "filterOut",
];
